<template>
    <div class="homepage">
        <div class="content-item first" :style="{height:bgHeight + 'px'}">
            <div class="first-text-wrapper">
                <p class="text-title">主打“轻阅读”</p>
                <p class="text-content">以娱乐生活为主体内容 </p>
                <p class="text-content"> 通过特色运营手段，培养用户阅读</p>
                <div class="download-btn-wrapper">
                    <a v-if="isHarmony" href="store://appgallery.huawei.com/app/detail?id=com.jifen.qukan.hm" class="ios" @click="report('下载按钮', '点击', '鸿蒙版下载')">下载</a>
                    <a v-else-if="isIos" href="https://itunes.apple.com/cn/app/id1113268900" class="ios" @click="report('下载按钮', '点击', 'IOS版下载')">立即下载</a>
                    <a v-else-if="!isIos" href="http://api.1sapp.com/app/download" class="ios" @click="setLayer('下载按钮', '点击', '安卓版下载')" >立即下载</a>
                    <!--<a v-else href="#" class="ios" @click="setLayer">立即下载</a>-->
                </div>
            </div>
        </div>
        <div v-if="isWeixin && show" class="first layer"  @touchmove.prevent  @click="hideLayer" :style="{height:bgHeight + 'px'}">
            <img src="../../../assets/img/mIndex/layer.png" alt="">
        </div>
        <Media></Media>
    </div>
</template>

<script>
import Media from './Media';

export default {
    name: 'HomePage',
    components: {
        Media,
    },
    data() {
        return {
            bgHeight: 600,
            isIos: /iPhone|iPod/i.test(navigator.userAgent),
            isHarmony: /harmony|arkweb/i.test(navigator.userAgent.toLocaleLowerCase()),
            isWeixin: false,
            show: false,
        };
    },
    methods: {
        setBgHeight() {
            let H = document.documentElement.clientHeight;
            this.bgHeight = H;
        },
        isW() {
            //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
            let ua = window.navigator.userAgent.toLowerCase();
            //通过正则表达式匹配ua中是否含有MicroMessenger字符串
            if (ua.match(/MicroMessenger/i) == 'micromessenger') {
                this.isWeixin = true;
            } else {
                this.isWeixin = false;
            }
            // console.log(ua.match(/MicroMessenger/i) == 'micromessenger', ua);
        },
        setLayer(category, action, label){
            this.report(category, action, label)
            if (this.isWeixin) {
                this.show = true;
            }
        },
        hideLayer() {
            this.show = false;
        },
        report (category, action, label) {
            window._czc.push(["_trackEvent",category,action,label])
        }
    },
    mounted() {
        this.setBgHeight();
        this.isW();
    },
};
</script>

<style  lang="less">
.homepage {
    width: 100%;
    font-family: PingFangSC-Regular;
}
.content-item {
    width: 100%;
    position: relative;
}
.first-text-wrapper {
    position: absolute;
    height: 180px;
    width: 100%;
    bottom: 0;
    left: 0;
    text-align: center;
}
.first {
    height: 100vh;
    background: url('../../../assets/img/mIndex/bg1.png') center;
    background-size: cover;
}
.text-title {
    font-size: 1rem;
    color: #ffffff;
    letter-spacing: 1.58px;
    padding-bottom: 0.312rem;
    padding-left: 0.75rem;
}
.text-content {
    opacity: 0.76;
    font-size: 0.535rem;
    color: #ffffff;
    letter-spacing: 1.61px;
    text-align: center;
    line-height: 0.821rem;
}
.download-btn-wrapper {
    padding-top: 0.428rem;
}
.ios {
    width: 6.14rem;
    height: 1.5rem;
    line-height: 1.5rem;
    vertical-align: center;
    text-align: center;
    display: inline-block;
    font-size: 0.714rem;
    color: #ffffff;
    background-color: #11c64c;
    border: 0px solid rgba(0, 217, 255, 0.6);
    border-radius: 5px;
    margin-right: 0.312rem;
}
.error-info {
    line-height: 1rem;
    text-align: center;
    font-size: 0.4rem;
    color: #ffffff;
    padding-bottom: 12px;
}
.layer {
    position: fixed;
    top: 0;
    right: 0;
    width: 100%;
    text-align: right;
    opacity: 0.6;
    background: #000000;
    z-index: 10000;
    img {
        margin-top: 10px;
        border-right: 10px;
    }
}

/*.android {*/
/*width: 3.92rem;*/
/*height: 1.5rem;*/
/*line-height: 1.5rem;*/
/*text-align: center;*/
/*color: #00d9ff;*/
/*display: inline-block;*/
/*border: 1px solid rgba(0, 217, 255, 0.6);*/
/*border-radius: 2.4px;*/
/*margin-left: 0.312rem;*/
/*}*/
</style>
